import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import { VenueContext } from "../../VenueContext";

import * as styles from "./styles.module.scss";

const TiledBackground = ({ children, storybook = false }) => {
  const venue = useContext(VenueContext);
  const className = classNames(styles.container, {
    [styles.storybook]: storybook,
    [styles.tiles]: venue === "Eltham",
    [styles.wallpaper]: venue === "Bexley",
  });

  return <div className={className}>{children}</div>;
};

TiledBackground.propTypes = {
  children: PropTypes.node.isRequired,
  storybook: PropTypes.bool,
};

export default TiledBackground;
